export const generateFilterPayload = (filters) => {
  return filters.map((filter) => {
    if (filter?.label === 'By Lead Stage' || filter?.label === 'By Case Stage') {
      return {
        update: {
          [filter?.label === 'By Case Stage' ? 'case_description.case_stage.sk' : 'lead_stage']: [filter?.from, filter?.to],
        },
        label: filter?.label,
      };
    } else if (filter?.label === 'By Viewed/ Unviewed') {
      return {
        eq: filter?.value,
        label: filter?.label,
      };
    } else if (filter?.label === 'By Position') {
      return {
        position: [
          {
            role: filter?.role,
            user_ids: Array.isArray(filter?.value) ? filter?.value?.map((user) => (typeof user === 'object' ? user?.value : user)) : [],
            data: filter?.value,
          },
        ],
        label: filter?.label,
      };
    }
    return {
      [filter?.condition]: filter?.value,
      label: filter?.label,
    };
  });
};
